import * as React from "react";
import { Query } from "react-apollo";
import { Row } from "reactstrap";

// GraphQL
import GetCompanyWorkOrders from "../../GraphQL/Queries/GetCompanyWorkOrders";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";

// Local components
import AnnualChart from "./WorkOrderCharts/AnnualChart";
import WeekChart from "./WorkOrderCharts/WeekChart";

class WorkOrders extends React.Component<{ companyId: string }> {
  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyWorkOrders} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the work orders</div>;
          }

          const workOrders = data.allWorkOrders;

          return (
            <Row
              style={{
                marginTop: "30px",
                marginBottom: "30px",
                minHeight: "300px"
              }}
            >
              <AnnualChart workOrders={workOrders} />
              <WeekChart workOrders={workOrders} />
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default WorkOrders;



// WEBPACK FOOTER //
// ./src/Containers/Reports/WorkOrderChartReports.tsx